module.exports = __webpack_public_path__ + "img/repairs.ba25a1fe.svg";